import { navigate } from 'gatsby';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import Button from '../../General/Button';
import {
  ExtraBalanceMessageSuccessWrapperStyled as ExtraBalanceMessageSuccessWrapper,
  ExtraBalanceMessageCompletedHeaderStyled as ExtraBalanceMessageCompletedHeader,
  ExtraBalanceMessageCompletedHeaderContainerStyled as ExtraBalanceMessageCompletedHeaderContainer,
} from './styles/ExtraBalanceMessageSuccessStyled';
import { ReactComponent as CoffeeIcon } from '../../../images/extra-saldo/ico_coffee_time.svg';
import { ExtraBalanceHeaderBottom } from '../styles/ExtraBalanceStyled';
import { GoogleTagManager, Strings } from '../../../helpers';

const ExtraBalanceMessageSuccess = ({ closePanel, category }) => {
  const handleVolverInicio = () => {
    closePanel();
    navigate('/home');
  };

  useEffect(() => {
    GoogleTagManager.pushToDataLayer({
      event: 'pagina-virtual',
      page: `/tienda/extra-saldo/${Strings.strToUrl(category)}/exito`,
      pagename: `Tienda - Extra Saldo - ${Strings.strFirstCaseUpper(
        category
      )}/exito`,
    });
  }, []);

  return (
    <ExtraBalanceMessageSuccessWrapper>
      <ExtraBalanceHeaderBottom />
      <ExtraBalanceMessageCompletedHeader>
        <ExtraBalanceMessageCompletedHeaderContainer>
          <h2>
            ¡WOMER!
            <br />
            {' Hemos recibido tu solicitud'}
          </h2>
          <CoffeeIcon />
          <p>
            En unos instantes estará disponible tu Extra Saldo, recibirás un SMS
            de confirmación por tu Extra Saldo activo
          </p>
        </ExtraBalanceMessageCompletedHeaderContainer>
      </ExtraBalanceMessageCompletedHeader>
      <Button
        click={handleVolverInicio}
        outline
        transparent
        color="purple"
        maxWidth="280px"
        margin="30px auto 20px auto"
      >
        Ir al inicio
      </Button>
    </ExtraBalanceMessageSuccessWrapper>
  );
};

ExtraBalanceMessageSuccess.propTypes = {
  closePanel: PropTypes.func.isRequired,
  category: PropTypes.string.isRequired,
};

export default ExtraBalanceMessageSuccess;
